import { Checkbox } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React from 'react';
import { useRowSelectionContext } from '.';

export const renderGridCheckboxCell =
  (
    numRows?: number,
    disabled?: boolean,
    isRowSelectable?: (row: Record<string, any>) => boolean
  ): GridColDef['renderCell'] =>
  ({ id, row }) => {
    const {
      clearSelectionPreview,
      isRowDisplayedSelected,
      isRowSelected,
      isRowSelectionPreviewed,
      previewSelection,
      toggleSelection,
    } = useRowSelectionContext();
    const rowSelectable = isRowSelectable ? isRowSelectable(row) : true;
    const displayedSelected = rowSelectable
      ? isRowDisplayedSelected
        ? isRowDisplayedSelected(id)
        : isRowSelected(id)
      : false;
    const selectionIsPreviewed = isRowSelectionPreviewed?.(id) ?? false;

    return (
      <Checkbox
        disabled={disabled || numRows === 0 || !rowSelectable}
        checked={displayedSelected}
        data-selection-preview={selectionIsPreviewed || undefined}
        sx={
          selectionIsPreviewed
            ? {
                bgcolor: 'action.hover',
                borderRadius: '50%',
                color: 'secondary.main',
                outline: '1px dashed',
                outlineColor: 'secondary.main',
                outlineOffset: '-2px',
                '&.Mui-checked': { color: 'secondary.main' },
              }
            : undefined
        }
        onMouseEnter={(event) => previewSelection?.(id, event.shiftKey)}
        onMouseMove={(event) => previewSelection?.(id, event.shiftKey)}
        onMouseLeave={() => clearSelectionPreview?.()}
        onClick={(event) => {
          event.stopPropagation();
          toggleSelection(id, event.shiftKey);
        }}
      />
    );
  };
